<template>
    <!-- start Home Slider -->
    <section class="w-full h-[80vh] sm:h-screenheader">
        <swiper
            :a11y="{
                prevSlideMessage: 'Anterior',
                nextSlideMessage: 'Siguiente',
            }"
            :pagination="{
                clickeable: true,
            }"
            :navigation="true"
            :autoplay="{
                delay: 8000,
                disableOnInteraction: true,
            }"
            :modules="modules"
            class="swiperSlider"
        >
            <swiper-slide>
                <Link href="/recetas" class="cursor-pointer">
                    <div
                        class="w-full h-[80vh] sm:h-screenheader bg-cover bg-no-repeat bg-right"
                        :style="`background-image: url(/images/home/slide1_bg.jpg)`"
                    >
                        <img
                            class="w-full pl-8 pt-8 h-full object-contain object-right-bottom"
                            :src="`/images/home/slide1_main.png`"
                            alt="Chokis®"
                            id="bannerBrownies"
                        />
                    </div>
                    <!-- <img
                        class="hidden sm:block w-full h-screenheader object-cover"
                        :src="`/images/home/slide2_desktop.jpg`" alt="Chokis®"
                    >
                    <img
                        class="sm:hidden w-full h-[80vh] object-cover"
                        :src="`/images/home/slide2_mobile.jpg`" alt="Chokis®"
                    > -->
                </Link>
            </swiper-slide>
            <swiper-slide>
                <img
                    class="hidden sm:block w-full h-screenheader object-cover"
                    :src="`/images/home/slide1_desktop.jpg`"
                    alt="Chokis®"
                />
                <img
                    class="sm:hidden w-full h-[80vh] object-cover"
                    :src="`/images/home/slide1_desktop.jpg`"
                    alt="Chokis®"
                />
            </swiper-slide>
        </swiper>
    </section>
    <!-- End Home Slider -->

    <section class="bg-blueCircles bg-effect-right" id="main-content">
        <div class="container py-8 md:py-16" ref="retailerSection">
            <h1 class="hidden">Chokis</h1>
            <h2 class="text-center mb-4 mt-8 uppercase">Recetas</h2>
            <div class="w-full max-w-6xl mx-auto py-4">
                <Link href="/recetas" class="mb-4 px-2 py-4 text-right font-bold">
                    Ver Recetas
                    <font-awesome-icon icon="fa-regular fa-angle-right" class="text-2xl align-middle ml-2" />
                </Link>
                <swiper
                    :a11y="{
                        prevSlideMessage: 'Anterior',
                        nextSlideMessage: 'Siguiente',
                    }"
                    :centeredSlides="false"
                    :spaceBetween="30"
                    :slidesPerView="1"
                    :grabCursor="true"
                    :loop="true"
                    :navigation="true"
                    :modules="modules"
                    class="swiperRetailers"
                    :breakpoints="{
                        320: {
                            slidesPerView: 1,
                        },
                        480: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                    }"
                >
                    <swiper-slide
                        v-for="(recipe, index) in recipes"
                        :key="index"
                        v-if="recipes.length"
                        class="flex justify-center items-center"
                    >
                        <div class="w-full rounded-lg overflow-hidden">
                            <div class="w-full flex justify-center items-center">
                                <img
                                    class="w-full h-auto"
                                    :src="
                                        recipe.thumbnail
                                            ? `/storage/recipes/${recipe.thumbnail}`
                                            : `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`
                                    "
                                    :alt="recipe.name"
                                />
                            </div>
                            <div class="bg-pink w-full h-24 flex justify-between items-center p-2 sm:p-4">
                                <p class="text-sm pr-2 md:text-base">{{ recipe.name }}</p>
                                <Link
                                    :href="`/recetas/${recipe.slug}`"
                                    class="text-sm md:text-base btn-white shrink-0"
                                    :aria-label="`Ver receta ${recipe.name}`"
                                >
                                    Ver Receta
                                </Link>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>

            <h2 class="text-center mb-4 uppercase">Productos</h2>
            <div class="w-full max-w-6xl mx-auto py-4">
                <Link href="/productos" class="mb-4 px-2 py-4 text-right font-bold" aria-label="Ver productos">
                    Ver Productos
                    <font-awesome-icon icon="fa-regular fa-angle-right" class="text-2xl align-middle ml-2" />
                </Link>
                <swiper
                    :a11y="{
                        prevSlideMessage: 'Anterior',
                        nextSlideMessage: 'Siguiente',
                    }"
                    :centeredSlides="false"
                    :spaceBetween="30"
                    :slidesPerView="1"
                    :grabCursor="true"
                    :loop="true"
                    :navigation="true"
                    :modules="modules"
                    class="swiperRetailers relative"
                    :breakpoints="{
                        320: {
                            slidesPerView: 1,
                        },
                        480: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                    }"
                >
                    <swiper-slide
                        v-for="(product, index) in products"
                        :key="index"
                        v-if="products.length"
                        class="flex justify-center items-center"
                    >
                        <div class="w-full rounded-lg overflow-hidden">
                            <div
                                class="w-full h-64 flex justify-center items-center bg-cover bg-no-repeat bg-center"
                                :class="product.background"
                            >
                                <img
                                    class="w-11/12 h-full object-contain"
                                    :src="product.image"
                                    :alt="product.name"
                                    loading="lazy"
                                />
                            </div>
                            <div class="bg-blue w-full h-24 flex justify-between items-center p-2 sm:p-4">
                                <p class="text-sm pr-2 md:text-base">
                                    {{ product.name }}
                                </p>
                                <Link
                                    :href="product.url"
                                    class="text-sm md:text-base btn-white shrink-0 hover:bg-red"
                                    :aria-label="`Ver más sobre ${product.name}`"
                                    >Ver más
                                </Link>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";

import { Navigation, Pagination, A11y, Autoplay } from "swiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Rellax from "rellax";

export default {
    name: "Home",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        products: Object,
        recipes: Object,
    },
    data() {
        return {
            modules: [Autoplay, Navigation, Pagination, A11y],
        };
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger);
        let rellax = new Rellax(".rellax");

        gsap.fromTo(
            "#bannerBrownies",
            {
                opacity: 1,
                translateX: 2000,
                translateY: 1000,
            },
            {
                opacity: 1,
                translateX: 0,
                translateY: 0,
                duration: 1,
            }
        );

        //Second section
        gsap.fromTo(
            this.$refs.secondSection,
            {
                opacity: 0,
                translateX: 200,
            },
            {
                opacity: 1,
                translateX: 0,
                duration: 1.3,
            }
        );

        gsap.fromTo(
            this.$refs.bannerSection,
            {
                opacity: 0,
                scale: "+=0.5",
            },
            {
                scrollTrigger: {
                    trigger: this.$refs.bannerSection,
                    toggleActions: "play none none none",
                },
                opacity: 1,
                scale: "-=0.5",
                duration: 1.3,
            }
        );

        gsap.fromTo(
            this.$refs.retailerSection,
            {
                opacity: 0,
                translateY: 100,
            },
            {
                scrollTrigger: {
                    trigger: this.$refs.retailerSection,
                    toggleActions: "play none none none",
                },
                opacity: 1,
                translateY: 0,
                duration: 1.3,
            }
        );
    },
};
</script>
<style>
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
}

.swiper-pagination-bullet-active {
    background: theme("colors.white");
}

.swiper-button-prev {
    left: 0px;
    right: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-prev:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

.swiper-button-next {
    right: 0px;
    left: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-next:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

/* swiperSlider */
.swiperSlider .swiper-button-prev {
    left: 2rem;
}

.swiperSlider .swiper-button-next {
    right: 2rem;
}

@media (max-width: 640px) {
    .swiper-button-prev,
    .swiper-button-next {
        width: 2.4rem;
        height: 2.4rem;
    }

    .swiperSlider .swiper-button-prev {
        left: 0.5rem;
    }

    .swiperSlider .swiper-button-next {
        right: 0.5rem;
    }
}

.swiper-button-lock {
    display: none !important;
}
</style>
